<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'modals.modal-edit-weights.title' | translate}}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="closeDialogue()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
@if (inputData?.decision_table) {
  <app-criteria-targets-weight-update
    [decisionTable]="inputData?.decision_table"
    [editMode]="inputData?.edit_mode"
    (weightsUpdated)="closeDialogue($event)"
    [evaluation_session_id]="inputData?.evaluation_session_id"
    (close)="closeDialogue()"
    />
}
